import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { PDFDownloadLink } from "@react-pdf/renderer";
import TaxInvoicePDF from './TaxInvoicePDF';

const TaxInvoiceDetails = () => {
    const location = useLocation();
    // const { taxInvoice,proformainvoice, companyDetails ,currency} = location.state || {};
    const { id } = useParams();

    const navigate = useNavigate();
    const [taxInvoice, setTaxInvoice] = useState(location.state?.taxInvoice || null);
    const [proformainvoice, setProformainvoice] = useState(location.state?.proformainvoice || null);
    const [companyDetails, setCompanyDetails] = useState(location.state?.companyDetails || null);
    const [currency, setCurrency] = useState(location.state?.currency || 'USD');
    const [loading, setLoading] = useState(!location.state);
    const [taxinvoiceNotes, setTaxInvoiceNotes] = useState("");
    const [taxinvoiceTerms, setTaxInvoiceTerms] = useState("");
    const [bankAccounts, setBankAccounts] = useState([]);


    console.log(location.state);
    useEffect(() => {
        if (!location.state) {
            // Fetch data from API if location.state is not available
            const fetchData = async () => {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem("user-info"));
                    const origin = localStorage.getItem("user-origin");
                    const token = userInfo?.token;

                    const response = await axios.get(`${backendUrl}/api/taxinvoice/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });
                    const data = response.data;
                    if (data.status === 'success') {
                        setTaxInvoice(data.taxinvoice);
                        setProformainvoice(data.proformainvoice);
                        setCompanyDetails(data.company);
                        setCurrency(data.proformainvoice?.quotation?.currency);

                    }
                } catch (error) {
                    console.error('Error fetching tax invoice details:', error);
                } finally {
                    setLoading(false);
                }
            };

            fetchData();
        }
    }, [id, location.state]);
    const fetchTITerms = async (currency) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotationterm`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const term = response.data.quotation_terms.data.find(term => term.type === "tax_invoice");
            // const formattedTerms = term ? term.value.replace(/{{currency}}/g, currency || "USD") : "";
            let formattedTerms = "";

            if (term) {
                // Choose the appropriate content based on client currency
                if (currency === 'AED') {
                    formattedTerms = term.value_local || term.value || "";
                    console.log('📝 Using UAE Local Client Terms (AED) for Proforma Invoice');
                } else if (currency === 'USD') {
                    formattedTerms = term.value_export || term.value || "";
                    console.log('📝 Using Export Client Terms (USD) for Proforma Invoice');
                } else {
                    // Fallback to default value if currency is neither AED nor USD
                    formattedTerms = term.value || "";
                    console.log('📝 Using Default Terms for Proforma Invoice');
                }

                // Replace currency placeholder if needed
                formattedTerms = formattedTerms.replace(/{{currency}}/g, currency || "USD");
            }
            setTaxInvoiceTerms(formattedTerms);
            setTaxInvoiceNotes(formattedTerms);

        } catch (error) {
            console.error("Error fetching quotation terms:", error);
        }
    };
    const fetchBankAccounts = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/bank-accounts?type=bank account`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                }
            });

            // setBankAccounts(response.data.account || []);
            const firstTwoAccounts = (response.data.account || []).slice(0, 2);
            setBankAccounts(firstTwoAccounts);
        } catch (error) {
            console.error("Error fetching bank accounts:", error);
            setBankAccounts([]);
        }
    };
    useEffect(() => {
        if (currency) {
            fetchTITerms(currency);
        }
    }, [currency]);
    useEffect(() => {
        fetchBankAccounts();
    }, []);

    const handleBackClick = () => {
        navigate(-1);
    };
    if (!proformainvoice || !companyDetails) {
        return <div>Missing Data. Please ensure you navigate from the correct page.</div>;
    }
    const hasDiscount = proformainvoice.discount_amount && proformainvoice.discount_amount > 0;
    const calculateVAT = (amount) => {
        if (currency === "USD") {
            return 0; // VAT is 0 if the currency is USD
        }
        return parseFloat((amount * 0.05).toFixed(2));
    };
    const vatAmount = calculateVAT(proformainvoice.basic_amount);

    const renderBankAccounts = () => {
        if (!bankAccounts || bankAccounts.length === 0) {
            return null;
        }

        // ✅ For only one bank account
        if (bankAccounts.length === 1) {
            const account = bankAccounts[0];
            return (
                <div style={styles.bankAccountSection}>
                    <div style={styles.bankAccountHeader}>
                        <h4 style={styles.bankAccountTitle}>Bank Account Details</h4>
                    </div>

                    <div style={styles.singleBankAccount}>
                        <div style={styles.bankDetailsRow}>
                            <span style={styles.label}>Account Name:</span>
                            <span style={styles.value}>{account.account_holder_name || "N/A"}</span>
                        </div>
                        <div style={styles.bankDetailsRow}>
                            <span style={styles.label}>Bank Name:</span>
                            <span style={styles.value}>{account.name || "N/A"}</span>
                        </div>
                        <div style={styles.bankDetailsRow}>
                            <span style={styles.label}>Account Number:</span>
                            <span style={styles.value}>{account.account_number || "N/A"}</span>
                        </div>
                        <div style={styles.bankDetailsRow}>
                            <span style={styles.label}>IBAN:</span>
                            <span style={styles.value}>{account.iban || "N/A"}</span>
                        </div>
                        {account.swift_code && (
                            <div style={styles.bankDetailsRow}>
                                <span style={styles.label}>SWIFT Code:</span>
                                <span style={styles.value}>{account.swift_code}</span>
                            </div>
                        )}
                        {account.branch && (
                            <div style={styles.bankDetailsRow}>
                                <span style={styles.label}>Branch:</span>
                                <span style={styles.value}>{account.branch}</span>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        // ✅ For multiple bank accounts
        return (
            <div style={styles.bankAccountSection}>
                <div style={styles.bankAccountHeader}>
                    <h4 style={styles.bankAccountTitle}>Bank Account Details</h4>
                </div>

                <div style={styles.twoColumnBankAccounts}>
                    {bankAccounts.map((account, index) => (
                        <div key={index} style={styles.bankAccountCard}>
                            <div style={styles.bankDetailsRow}>
                                <span style={styles.label}>Account Name:</span>
                                <span style={styles.value}>{account.account_holder_name || "N/A"}</span>
                            </div>
                            <div style={styles.bankDetailsRow}>
                                <span style={styles.label}>Bank Name:</span>
                                <span style={styles.value}>{account.name || "N/A"}</span>
                            </div>
                            <div style={styles.bankDetailsRow}>
                                <span style={styles.label}>Account Number:</span>
                                <span style={styles.value}>{account.account_number || "N/A"}</span>
                            </div>
                            <div style={styles.bankDetailsRow}>
                                <span style={styles.label}>IBAN:</span>
                                <span style={styles.value}>{account.iban || "N/A"}</span>
                            </div>
                            {account.swift_code && (
                                <div style={styles.bankDetailsRow}>
                                    <span style={styles.label}>SWIFT Code:</span>
                                    <span style={styles.value}>{account.swift_code}</span>
                                </div>
                            )}
                            {account.branch && (
                                <div style={styles.bankDetailsRow}>
                                    <span style={styles.label}>Branch:</span>
                                    <span style={styles.value}>{account.branch}</span>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        );
    };


    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Tax Invoice Details</h4>
                                <div className="page-title-right">

                                    <div className="page-title-right d-flex align-items-center">

                                        {/* <PDFDownloadLink
                                            document={<TaxInvoicePDF proformainvoice={proformainvoice} companyDetails={companyDetails} taxinvoiceTerms={taxinvoiceTerms} />}
                                            fileName={`${proformainvoice.tax_invoice?.ref_no || taxInvoice.ref_no}.pdf`}
                                            >
                                            {({ loading }) => (
                                                <button
                                                    style={{
                                                        padding: "6px 16px",
                                                        backgroundColor: "#415094",
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "6px",
                                                        cursor: "pointer",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {loading ? " " : "Download"}
                                                </button>
                                            )}
                                        </PDFDownloadLink> */}
                                        <button
                                            onClick={() => {
                                                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                                                const userInfo = JSON.parse(localStorage.getItem("user-info"));
                                                const origin = localStorage.getItem("user-origin");
                                                const token = userInfo?.token;
                                                const taxInvoiceId = proformainvoice.tax_invoice?.id || id;
                                                const downloadUrl = `${backendUrl}/api/taxinvoice/${taxInvoiceId}/download`;

                                                const link = document.createElement('a');
                                                link.href = downloadUrl;
                                                link.setAttribute('download', `${proformainvoice.tax_invoice?.ref_no || taxInvoice.ref_no}.pdf`);
                                                document.body.appendChild(link);

                                                fetch(downloadUrl, {
                                                    headers: {
                                                        'Authorization': `Bearer ${token}`,
                                                        'Tenant-Origin': origin,
                                                    }
                                                })
                                                    .then(response => response.blob())
                                                    .then(blob => {
                                                        const url = window.URL.createObjectURL(blob);
                                                        link.href = url;
                                                        link.click();
                                                        window.URL.revokeObjectURL(url);
                                                        document.body.removeChild(link);
                                                    })
                                                    .catch(error => console.error('Download failed:', error));
                                            }}
                                            style={{
                                                padding: "6px 16px",
                                                backgroundColor: "#415094",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "6px",
                                                cursor: "pointer",
                                                fontSize: "14px",
                                            }}
                                        >
                                            Download
                                        </button>
                                        &nbsp;&nbsp;

                                        <button style={{
                                            padding: "6px 16px",
                                            backgroundColor: "#415094",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                        }}
                                            onClick={handleBackClick} className="btn btn-secondary  back">Back</button>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div> </div>


                    {/* A4 ProformaInvoice Layout */}
                    <div style={styles.page}>
                        {/* Header Section */}
                        <div style={styles.header}>
                            <div>
                                <h2 style={styles.companyName}>{companyDetails?.company_name}</h2>
                                <p style={styles.companyDetails}>
                                    {companyDetails?.phone} <br />
                                    {companyDetails?.email}<br />
                                    <p dangerouslySetInnerHTML={{ __html: companyDetails?.company_address }} />
                                </p>
                            </div>
                            <div style={styles.topRight}>
                                <img
                                    src="/images/655c8bbb23be8.png" // Provide the image source
                                    alt="Company Logo"
                                    style={styles.image}
                                />



                                <div style={styles.proformainvoiceTitle}>Tax Invoice</div>
                            </div>
                        </div><hr style={styles.hr} />

                        {/* ProformaInvoice Details */}
                        <div style={styles.detailsSection}>
                            <div>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "90px" }}>Project:</strong>
                                    <span>{proformainvoice.quotation?.project?.name || " "}</span>
                                </p>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "90px" }}>Document No:</strong>
                                    <span>{proformainvoice.tax_invoice?.ref_no || taxInvoice?.ref_no || ''}</span>
                                </p>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "90px" }}>Date:</strong>
                                    <span>
                                        {proformainvoice.created_at
                                            ? new Date(proformainvoice.created_at).toLocaleDateString().replace(/\//g, '-')
                                            : proformainvoice.tax_invoice?.created_at
                                                ? new Date(proformainvoice.tax_invoice.created_at).toLocaleDateString().replace(/\//g, '-')
                                                : taxInvoice?.created_at
                                                    ? new Date(taxInvoice.created_at).toLocaleDateString().replace(/\//g, '-')
                                                    : ""}
                                    </span>
                                </p>


                            </div>
                            <div>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "65px" }}>Customer:&nbsp;</strong>{proformainvoice.quotation?.project?.client?.name || " "}
                                </p>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "65px" }}>Address:&nbsp;</strong>{proformainvoice.quotation?.project?.client?.address || " "}
                                </p>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "90px" }}>Contact Phone:</strong>{proformainvoice.quotation?.project?.client?.contacts[0]?.phone || ""}
                                </p>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "90px" }}>Contact Email:</strong> {proformainvoice.quotation?.project?.client?.contacts[0]?.email || ""}
                                </p>
                            </div>
                        </div><br /><br />

                        {/* Table Section */}
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.tableHeader}>No</th>
                                    <th style={styles.tableHeader}>Product</th>
                                    <th style={styles.tableHeader}>Description</th>
                                    <th style={styles.tableHeader}>QTY</th>

                                    <th style={styles.tableHeader}>Rate</th>
                                    <th style={styles.tableHeader}>VAT(5%)</th>

                                    <th style={styles.tableHeader}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {proformainvoice.quotation && proformainvoice.quotation.product_item_details && proformainvoice.quotation.product_item_details.length > 0 ? (
                                    proformainvoice.quotation.product_item_details.map((item, index) => {
                                        const vat = calculateVAT((item.price));
                                        return (
                                            <tr key={index}>
                                                <td style={styles.tableCell}>{index + 1}</td>
                                                <td style={styles.tableCell}>{item.product ? item.product.product_name : ""}</td>
                                                <td style={styles.tableCell}>{item.item_description || ""}</td>
                                                <td style={styles.tableCell}>{item.quantity || ""}</td>
                                                <td style={styles.tableCell}>{item.price || ""}</td>
                                                <td style={styles.tableCell}>{vat || "0"}</td>
                                                <td style={styles.tableCell}>{item.subtotal || ""}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center", padding: "10px", fontStyle: "italic" }}>
                                            No items available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* Footer Section */}
                        <div style={styles.footer}>

                            {/* {hasDiscount && (
                                <div>
                                    <p>
                                        <strong>One Time Discount{proformainvoice.quotation?.discount_type === 'percentage' ? ' (%)' : ''}:</strong>&nbsp; {proformainvoice.discount_amount || "N/A"}
                                    </p>
                                </div>
                            )} */}


                            <p>
                                <strong>Total Excl. Tax :</strong> {proformainvoice.basic_amount || ""}
                            </p>
                            {/* <p>
                            <strong>Total Exc. Vat :</strong> {(proformainvoice.amount - proformainvoice.deduction_amount).toFixed(2) ||proformainvoice.amount|| ""}
                        </p> */}
                            <p>
                                <strong>Total Vat (5%):</strong> {vatAmount || "0"}
                            </p>
                            <p>
                                <strong>Total Inc. VAT :</strong> {proformainvoice.total_amount_with_vat || ""}
                            </p>
                            {/* <p>
                            <strong>Total Inc. VAT :</strong> {proformainvoice.total_amount_with_vat || "N/A"}
                        </p> */}
                            {/* <p>
                            <strong>Advanced Amount (%):</strong> {proformainvoice.advanced_amount || "N/A"}
                        </p>
                        <p>
                            <strong>Balance Amount (%):</strong> {proformainvoice.balance || "N/A"}
                        </p> */}
                            <br /><br />
                            {/* <div style={styles.terms}>
                            {proformainvoice.quotation?.notes && (
                                <div>
                                    <div dangerouslySetInnerHTML={{ __html: proformainvoice.quotation?.notes }} />
                                </div>
                            )}
                        </div> */}
                            <div style={styles.terms}>
                                <div>

                                    {taxinvoiceTerms && (
                                        <div dangerouslySetInnerHTML={{ __html: taxinvoiceTerms }} />

                                    )}</div>
                                {bankAccounts && (
                                    <div>{renderBankAccounts()}</div>
                                )}
                            </div>
                        </div>
                        <div style={styles.signfooter}>
                            <div style={styles.signatureSection}>
                                {["Stamp", "Authorized"].map((role, index) => (
                                    <div key={index} style={styles.signatureBlock}>
                                        <p>--------------------------</p> {/* Placeholder line */}
                                        <p style={{ marginBottom: 0, lineHeight: "14px" }}>{role}</p>
                                        <p>{role === "Stamp" ? "" : "Signature"}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        </div >
    );
};

export default TaxInvoiceDetails;

const styles = {
    page: {
        width: "210mm",
        minHeight: "200mm",
        margin: "0 auto",
        padding: "10mm",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#ffffff",
        border: "1px solid #ddd",
        fontSize: "12px",
        borderRadius: "12px"
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        // marginBottom: "20px",
    },
    companyName: {
        fontSize: "18px",
        fontWeight: "bold",
        color: "#415094",
    },

    companyDetails: {
        fontSize: "14px",
        marginTop: "-7px",
        color: "#415094",

    },
    proformainvoiceTitle: {
        fontSize: "24px",
        color: "#415094",
        // marginBottom: "0px",

        marginLeft: "10px",
        lineHeight: ".4",
        // Add some margin between the image and the title
    },
    headerRight: {
        display: "flex",  // Make the container a flexbox to align the image and title side by side
        alignItems: "center", // Vertically align the content in the center
    },
    hr: {
        marginTop: "-7px"
    },
    topRight: {
        alignSelf: "start",
        textAlign: "right",
    },
    Right: {
        alignSelf: "start",
        textAlign: "right",
        marginTop: "20px",
    },
    image: {

        objectFit: "contain",
        marginBottom: "20px",
        maxWidth: "214px",
        maxHeight: "100px",


    },
    detailsSection: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "25px",
        marginTop: "10px",
        lineHeight: "1",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: "20px",
        lineHeight: "3",

    },
    tableHeader: {
        borderBottom: "1px solid #ddd",
        padding: "8px",
        textAlign: "left",
        fontWeight: "bold",
    },
    tableCell: {
        borderBottom: "1px solid #ddd",
        padding: "8px",
        textAlign: "left",
    },
    footer: {
        marginTop: "30px",
        textAlign: "right",
    },
    terms: {
        fontSize: "12px",
        marginTop: "20px",
        textAlign: "left",
    },
    signfooter: {
        marginTop: "150px",
        textAlign: "center",

    },
    signatureSection: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        marginTop: "20px",
    },
    signatureBlock: {
        textAlign: "center",
    },
    signatureImage: {
        width: "120px",
        height: "50px",
        objectFit: "contain",
        marginBottom: "10px",
    },
    bankAccountSection: {
        marginTop: "30px",
        padding: "15px",
        border: "1px solid #ddd",
        borderRadius: "8px",
    },
    bankAccountHeader: {
        display: "flex",
        alignItems: "center",
        marginBottom: "15px",
    },
    bankAccountTitle: {
        fontSize: "16px",
        fontWeight: "bold",
        margin: 0,
    },
    singleBankAccount: {
        textAlign: "left",
    },
    twoColumnBankAccounts: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "20px",
        alignItems: "start",
    },
    bankAccountCard: {
        padding: "12px",
        border: "1px solid #e0e0e0",
        borderRadius: "6px",
        backgroundColor: "white",
        fontSize: "12px",
    },
    bankDetailsRow: {
        display: "flex",
        justifyContent: "flex-start",
        marginBottom: "4px",
    },
    label: {
        width: "130px", // ensures all values start from same vertical line
        fontWeight: "bold",
    },
    value: {
        // flex: 1,
        paddingLeft: "15px",
    },
};
